var path = '/templates/projects.dashboard/device_distribution_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.deviceDistributionChart.debaisugoto_no_haishin' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.campaigns class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.dashboard/device_distribution_chart.html
// module id = 1453
// module chunks = 0